import { type Components, type Theme } from "@mui/material/styles";

export const inputLabel: Components<Theme>["MuiInputLabel"] = {
  defaultProps: {
    shrink: true,
  },
};
